import React, { useEffect, useState } from 'react';

export default function DebugMultiPressAlert({
  info,
  count = 7,
  children,
  ...others
}) {
  const [debugCounter, setDebugCounter] = useState(0);
  useEffect(() => {
    if (debugCounter === count) {
      alert(info);
    }
  }, [debugCounter, count]);
  return (
    <div onClick={() => setDebugCounter(debugCounter < count ? debugCounter + 1 : 0)} {...others}>
      {children}
    </div>
  );
}
